export const stayPromotions = {
  title: "Promociones por estancia",
  description: "Ofrece descuentos especiales a tus huéspedes por estadías largas",
  newPromotion: "Nueva Promoción",
  loading: "Cargando promociones...",
  close: "Cerrar",
  cancel: "Cancelar",
  noLimit: "Sin límite",

  status: {
    active: "Activa",
    paused: "Pausada",
  },

  card: {
    stay: "Estadía",
    discount: "Descuento",
    validity: "Validez",
    edit: "Editar",
    delete: "Eliminar",
  },

  nights: {
    range: "{min} - {max} noches",
    min: "{min}+ noches",
  },

  empty: {
    title: "No hay promociones configuradas",
    description: "Crea promociones para incentivar estadías más largas y aumentar tus reservas",
    create: "Crear Primera Promoción",
  },

  form: {
    editTitle: "Editar Promoción",
    createTitle: "Nueva Promoción",
    nameLabel: "Nombre de la promoción",
    namePlaceholder: "Ej: Descuento 7 Noches, Promo Semana",
    minNights: "Noches mínimas",
    maxNights: "Noches máximas",
    optional: "(opcional)",
    noLimitPlaceholder: "Sin límite",
    discountType: "Tipo de descuento",
    percentage: "Porcentaje",
    fixedAmount: "Monto Fijo",
    discountValue: "Valor del descuento",
    validFrom: "Válida desde",
    validTo: "Válida hasta",
    activateNow: "Activar promoción inmediatamente",
    saving: "Guardando...",
    update: "Actualizar",
    create: "Crear Promoción",
  },

  invoice: {
    title: "Ejemplo de Ahorro",
    pricePerNight: "Precio por noche",
    numberOfNights: "Número de noches",
    subtotal: "Subtotal",
    discountApplied: "Descuento aplicado",
    totalToPay: "Total a pagar",
    guestSaves: "El huésped ahorra {amount}",
  },

  statusModal: {
    activateTitle: "Activar promoción",
    pauseTitle: "Pausar promoción",
    activateDescription: '¿Quieres activar la promoción "{name}" para que se aplique a nuevas reservas?',
    pauseDescription: '¿Quieres pausar la promoción "{name}"?',
    confirm: "Confirmar",
  },

  deleteModal: {
    title: "Eliminar promoción",
    warningStrong: "Esta acción no se puede deshacer.",
    warningText: "Antes de eliminar, asegúrate de que ya no necesites la promoción {name}.",
    confirmLabel: "Escribe el nombre exacto para confirmar:",
    confirmPlaceholder: "Escribe exactamente el nombre de la promoción",
    hint: "Pega o escribe el nombre tal cual aparece arriba para habilitar el botón de eliminar.",
    deleting: "Eliminando...",
    confirmDelete: "Eliminar definitivamente",
  },

  toasts: {
    nameRequired: "Por favor ingresa un nombre",
    minNightsWarning: "Min noches >= 1",
    selectRatePlan: "Selecciona un Rate Plan base",
    updated: "Promoción actualizada",
    created: "Promoción creada",
    saveFailed: "No se pudo guardar",
    saveError: "Error al guardar",
    activated: "Promoción activada",
    pausedToast: "Promoción pausada",
    updateFailed: "No se pudo actualizar",
    statusError: "Error al cambiar estado",
    deleted: "Promoción eliminada",
    deleteFailed: "No se pudo eliminar",
    deleteError: "Error al eliminar",
  },
};
